
namespace TabAurous.Production {
    export class LossReportBagWiseOptions {
        items: TabAurous.Production.WIPMovementRow[];
    }

    export class LossReportBagWisePanel extends Serenity.TemplatedPanel<WIPMovementRowOptions> {
        constructor(container: JQuery, opt: WIPMovementRowOptions) {
            super(container, opt);

            //Grouping
            var items = this.options.items;

            var bagno = 'BAG';
            var department = 'DEPT';
            var data = [0];

            var bagarray = [bagno];
            var names = [department];
            bagarray.pop();
            names.pop();
            for (var i = 0; i < items.length; i++) {
                var exists = false;
                for (var k = 0; k < bagarray.length; k++) {
                    if (items[i].BagNo == bagarray[k])
                        exists = true;
                }
                if (!exists)
                    bagarray.push(items[i].BagNo);
                exists = false;
                for (var k = 0; k < names.length; k++) {
                    if (items[i].DeptName == names[k])
                        exists = true;
                }
                if (!exists)
                    names.push(items[i].DeptName);

            }
            var dataarray = [{ name, data }];
            dataarray.pop();
            for (var i = 0; i < names.length; i++) {
                var name = names[i];
                var data = [4];
                data.pop();
                var obj = { name, data }
                dataarray.push(obj);
            }
            //for (var i = 0; i < dataarray.length; i++) {
            //    for (var b = 0; b < bagarray.length; b++) {
            //        if (items[j].BagNo == bagarray[b]) {
            //            for (var j = 0; j < items.length; j++) {
            //                if (dataarray[i].name == items[j].DeptName) {
            //                    dataarray[i].data.push(items[j].Loss);
            //                }
            //            }
            //        }
            //    }
            //}


            //working Code
            //for (var b = 0; b < bagarray.length; b++) {
            //    for (var j = 0; j < items.length; j++) {
            //        for (var i = 0; i < dataarray.length; i++) {
            //            if (items[j].BagNo == bagarray[b] && dataarray[i].name == items[j].DeptName) {
            //                dataarray[i].data.push(parseFloat(items[j].Loss.toFixed(2)));
            //            } else
            //                dataarray[i].data.push(0);
            //        }
            //    }
            //}

            for (var b = 0; b < bagarray.length; b++) {
                for (var i = 0; i < dataarray.length; i++) {
                    var loss = 0.0;
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].BagNo == bagarray[b] && dataarray[i].name == items[j].DeptName) {
                            loss+=parseFloat(items[j].Loss.toFixed(3));
                        }
                        //else
                        //    dataarray[i].data.push(0);
                    }
                    dataarray[i].data.push(loss);
                }
                //for (var i = 0; i < dataarray.length; i++) {
                //    if (dataarray[i].data.length < dataarray.length) {
                //        var count = dataarray.length - dataarray[i].data.length;
                //        for (var c = 0; c < count; c++)
                //            dataarray[i].data.push(0);

                //    }
                //}
            }

            //var _dataarray = [{ name, data }];
            //_dataarray.pop();
            //for (var b = 0; b < bagarray.length; b++) {
            //    var name = "";
            //    for (var k = 0; k < names.length; k++) {
            //        name = names[i];

            //    }
            //}
            /*
             * Wax,{1,2}
             * Polishing,{1}
             * Filing,{2,3}
             * */

            //var name = "DEPT";
            //var data = [5,6];
            //var obj  = { name, data }
            var x = dataarray;

            //var ser = [{ name, data }];
            //ser.pop();
            //for (var i = 0; i < namearray.length; i++) {
            //    name = namearray[i];
            //    data = dataarray[i];
            //    var newseries = { name, data };
            //    ser.push(newseries);
            //}
            var options = {
                series: dataarray
                    /*[{
                    name: 'Marine Sprite',
                    data: [44, 55, 41, 37, 22, 43, 21]
                }, {
                    name: 'Striking Calf',
                    data: [53, 32, 33, 52, 13, 43, 32]
                }, {
                    name: 'Tank Picture',
                    data: [12, 17, 11, 9, 15, 11, 20]
                }, {
                    name: 'Bucket Slope',
                    data: [9, 7, 5, 8, 6, 9, 4]
                }, {
                    name: 'Reborn Kid',
                    data: [25, 12, 19, 32, 25, 24, 10]
                }]*/,
                chart: {
                    type: 'bar',
                    height: 250,
                    stacked: true,
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                    },
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                title: {
                    text: 'Bag Wise Loss'
                },
                xaxis: {
                    categories: bagarray,
                    labels: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                yaxis: {
                    title: {
                        text: "Bag Wise Loss"
                    },
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val
                        }
                    }
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left',
                    offsetX: 40
                }
            };
            //var x = document.getElementById('TabAurous_Reports_WIPMovementRowPanel13_chartContainer');
            var y = container[0].childNodes[0];
            var chart = new ApexCharts(y, options);
            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class LossReportBagWiseGrid extends _Ext.GridBase<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.LossReport'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return LossReportService.baseUrl; }

        private chartContainer: JQuery;
        private chartPanel: LossReportBagWisePanel;
        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            this.view.setGrouping([{
                getter: 'BagNo',

                displayTotalsRow: false

            }])
            return grid;
        }

        onViewProcessData(response: Serenity.ListResponse<WIPMovementRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px;' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new LossReportBagWisePanel(this.chartContainer, { items: response.Entities });


            return response;
        }

        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle:"Loss Report(Bag Wise)"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}